export default __webpack_public_path__ + "static/media/arrow.8af1bf94.svg";